import physics from '../assets/img/physics.jpg';
import algebra from '../assets/img/algebra.jpeg';
import chemistry from '../assets/img/chemistry.jpg';
import english from '../assets/img/english.jpg';

export const COURSES = [
    {
        id: 0,
        courseNumber: 'Physics I',
        name: 'Basic Physics',
        year: 2019,
        image: physics,
        teacher: 'Henry'    
    },
    {
        id: 1,
        courseNumber: 'Maths I',
        name: 'Algebra',
        year: 2019,
        image: algebra,
        teacher: 'Talha'    
    },
    {
        id: 2,
        courseNumber: 'Chemistry I',
        name: 'Basic Chemistry',
        year: 2019,
        image: chemistry,
        teacher: 'Talha'    
    },
    {
        id: 3,
        courseNumber: 'English I',
        name: 'Basic English',
        year: 2019,
        image: english,
        teacher: 'Henry'    
    }
];